import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("om_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Autentificare eșuată.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-paper text-ink flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="font-display text-4xl mb-2">
          Oana <span className="italic">Mudura</span>
        </div>
        <div className="eyebrow mb-10">Redacție · Journal</div>
        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="eyebrow">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-ink/30 py-3 outline-none focus:border-ink transition-colors mt-1"
              required
            />
          </div>
          <div>
            <label className="eyebrow">Parolă</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-ink/30 py-3 outline-none focus:border-ink transition-colors mt-1"
              required
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-700">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit"
            disabled={loading}
            className="eyebrow border border-ink px-8 py-4 hover:bg-ink hover:text-paper transition-colors w-full disabled:opacity-50"
          >
            {loading ? "…" : "Autentificare"}
          </button>
        </form>
      </div>
    </div>
  );
}
